import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";

// @mui material components
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

// Images / wrappers
import bgImage from "assets/images/bg-home.jpg";
import BasicLayout from "pages/Authentication/components/BasicLayout";

export default function Loading() {
  const { currentUser, mongoUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let attempts = 0;
    const id = setInterval(() => {
      attempts += 1;

      // If auth is now valid ➜ go back to the intended page
      if (currentUser && mongoUser) {
        const dest = location.state?.from?.pathname || "/";
        navigate(dest, { replace: true });
        clearInterval(id);
      }

      // Give up after ~30s (10×3s) to avoid infinite spinners
      if (attempts > 10) clearInterval(id);
    }, 3000); // every 3s

    return () => clearInterval(id);
  }, [currentUser, mongoUser, location.state, navigate]);

  return (
    <BasicLayout image={bgImage}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100%",
        }}
      >
        <CircularProgress size={60} thickness={4} color="light" />
      </Box>
    </BasicLayout>
  );
}
